import React from "react";
import BlogThirty from "../component/BlogThirty";

function BlogThirtyContainer() {
  return <BlogThirty />;
}
export default BlogThirtyContainer;
